export default "__VITE_ASSET__K6_uP$XX__"